/// <amd-module name="Agile/Common/Redux/HubTeam/HubTeamActions" />

import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { ITeam } from "Agile/Contracts/Common";

export const enum HubTeamActionTypes {
    Initialize = "HubTeam/Initialize"
}

export const HubTeamActions = {
    initialize: (team: ITeam) => createAction(HubTeamActionTypes.Initialize, { team })
};

export type HubTeamActions = ActionsUnion<typeof HubTeamActions>;
